import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useRotaBase from '../../utils/useRotaBase';
import { FaAngleDown, FaAngleRight, FaSignOutAlt, FaBars } from 'react-icons/fa';

import {
  Container, Logo, BotaoIcone, SoMobile, SoDesktop,
  Menu, MenuItem, MenuBotao, Dropdown, DropdownItem,
  DropdownBotao, SubDropdown
} from './styles';

import IconeDinamico from '../IconeDinamico';
import MenuMobile from '../MenuMobile';

import api from '../../services/api';
import { IMenSis } from '../../types/MenSis';
import Context, { IContext } from '../../context/Context';
import { iconeMenu, temFilhos } from '../../utils/menu';

const urlLogo = 'https://tifire.com/assets/img/fogo2.png';

export default function Header() {
  const rotaBase = useRotaBase();
  const { atalhos, setAtalhos }: IContext = useContext(Context);
  const navigate = useNavigate();

  const [abrirMenuMobile, setAbrirMenuMobile] = useState(false);
  const [menuSistema, setMenuSistema] = useState<IMenSis[]>([]);

  async function getData() {
    try {
      const [responseAtalhos, responseMenuSistema] = await Promise.all([
        api.get('/atalhos'),
        api.get('/menu')
      ])

      if (responseAtalhos.status === 200) {
        const filhos = [{ mensis: 'Início', rot: '/inicio', nomico: 'FaHome' }, ...(responseAtalhos.data.data || [])];

        const atalhos = {
          filhos,
          mensis: 'Atalhos',
          nomico: 'FaBookmark'
        }

        setAtalhos(atalhos);
      }
      if (responseMenuSistema.status === 200) {
        setMenuSistema(responseMenuSistema.data.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  }

  // Navega e tira o foco do botão, para o dropdown (aberto por :focus-within) fechar
  function irPara(item: IMenSis) {
    if (temFilhos(item) || !item.rot) return;

    navigate(`${rotaBase}${item.rot}`);
    (document.activeElement as HTMLElement | null)?.blur();
  }

  function sair() {
    navigate(`${rotaBase}/login`);
  }

  useEffect(() => {
    getData();
  }, []);

  // Menu do topo (desktop): atalhos + menu do sistema, até 3 níveis
  const menuTopo: IMenSis[] = atalhos ? [atalhos, ...menuSistema] : menuSistema;

  return (
    <Container>
      <SoMobile>
        <BotaoIcone
          onClick={() => setAbrirMenuMobile(true)}
          aria-label='Abrir menu'
          aria-expanded={abrirMenuMobile}
        >
          <FaBars size={20} />
        </BotaoIcone>
      </SoMobile>

      <Logo src={urlLogo} alt='TI.Fire Sistemas' />

      <SoDesktop>
        <Menu aria-label='Menu principal'>
          {menuTopo.map((menSis, index) => (
            <MenuItem key={index}>
              <MenuBotao
                onClick={() => irPara(menSis)}
                aria-haspopup={temFilhos(menSis) || undefined}
              >
                <IconeDinamico nome={iconeMenu(menSis)} size={16} />
                {menSis.mensis}
                {temFilhos(menSis) && <FaAngleDown className='seta' />}
              </MenuBotao>
              {temFilhos(menSis) && (
                <Dropdown>
                  {menSis.filhos!.map((filho, indexFilho) => (
                    <DropdownItem key={indexFilho}>
                      <DropdownBotao onClick={() => irPara(filho)}>
                        <IconeDinamico nome={iconeMenu(filho)} size={15} />
                        <span>{filho.mensis}</span>
                        {temFilhos(filho) && <FaAngleRight />}
                      </DropdownBotao>
                      {temFilhos(filho) && (
                        <SubDropdown>
                          {filho.filhos!.map((neto, indexNeto) => (
                            <DropdownBotao key={indexNeto} onClick={() => irPara(neto)}>
                              <IconeDinamico nome={iconeMenu(neto)} size={15} />
                              <span>{neto.mensis}</span>
                            </DropdownBotao>
                          ))}
                        </SubDropdown>
                      )}
                    </DropdownItem>
                  ))}
                </Dropdown>
              )}
            </MenuItem>
          ))}
        </Menu>
      </SoDesktop>

      <BotaoIcone onClick={sair} aria-label='Sair' title='Sair'>
        <FaSignOutAlt size={20} />
      </BotaoIcone>

      <MenuMobile
        aberto={abrirMenuMobile}
        onFechar={() => setAbrirMenuMobile(false)}
        menuSistema={menuSistema}
        atalhos={atalhos?.filhos || []}
        onSair={sair}
      />
    </Container>
  );
}
